up.compiler('[submit-actions-modal-link]', (element, data) => {
  element.addEventListener('click', () => {
    up.layer.open({ fragment: data.modalHtml, target: '[submit-actions-modal]' })
  })
})
